import React from "react";
import { createSvgIconComponent } from "../";

export const IconCreditCard = createSvgIconComponent({
  children: [
    <path
      key="part-1"
      d="M14.047 12.367H2.953a.73.73 0 01-.736-.737V5.737A.73.73 0 012.953 5h11.05a.73.73 0 01.737.737v5.85a.708.708 0 01-.693.78v0z"
      stroke="#333"
      strokeWidth=".8"
      strokeMiterlimit="10"
    />,
    <path
      key="part-2"
      d="M3.733 8.9h4.334-4.334zm6.934 0h2.166-2.166zm-6.934 1.3h1.734-1.734z"
      fill="#333"
    />,
    <path
      key="part-3"
      d="M3.733 10.2h1.734M3.733 8.9h4.334-4.334zm6.934 0h2.166-2.166z"
      stroke="#333"
      strokeWidth=".8"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <path key="part-4" d="M2 7.167h13H2z" fill="#333" />,
    <path
      key="part-5"
      d="M2 7.167h13"
      stroke="#333"
      strokeWidth=".8"
      strokeMiterlimit="10"
    />,
  ],
  fill: "none",
  viewBox: "0 0 18 18",
});
